import type { Chapter } from '@code-arcade/engine'

export const chapter3: Chapter = {
  id: 'chapter-3',
  number: 3,
  title: 'On Fire',
  company: 'Blink.io',
  devTitle: 'Senior Engineer',
  conflict: 'Flash sale, stampede, no rate limiter.',
  intro: [
    {
      character: 'the-algorithm',
      mood: 'idle',
      dialogue: 'Three months in. Black Friday hits Blink.io. Two million concurrent users.',
    },
    {
      character: 'dev-lama',
      mood: 'stressed',
      dialogue: "We're out of memory. The sort nodes are writing to disk.",
    },
    {
      character: 'barry-holt',
      mood: 'urgent',
      dialogue:
        'Merge sort is allocating 200MB per sort node. We have 40 nodes. That is 8 gigabytes for sorting alone.',
    },
    {
      character: 'priya-nair',
      mood: 'idle',
      dialogue:
        'Quick sort. In-place. Zero heap allocation. O(log n) call stack. Same average speed.',
    },
    {
      character: 'dev-lama',
      mood: 'stressed',
      dialogue: 'Worst case is O(n²). What if we hit it during the sale?',
    },
    {
      character: 'priya-nair',
      mood: 'happy',
      dialogue:
        'Randomize the pivot. Worst case becomes so unlikely it is theoretical. Ship it.',
    },
  ],
  challengeIds: ['quick-sort'],
}
